import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'
import PropTypes from "prop-types";
import { get } from 'lodash'
import { Carts, CartItems } from "@gratify-eu/entities"

import entities from '~/entities'

export default kea({
  path: () => ['scenes', 'cart'],

  actions: ({ constants }) => ({
    changeQuantity: (item, quantity) => ({item, quantity}),
    removeItem: (item) => ({item}),
  }),

  selectors: ({ constants, selectors }) => ({
    activeCart: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        return activeCart
      },
      PropTypes.object
    ],
    activeShop: [
      () => [
        entities.selectors.activeShop
      ], (activeShop) => {
        return activeShop
      },
      PropTypes.object
    ],
    hasContents: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        return activeCart.contents && activeCart.contents.length > 0
      },
      PropTypes.bool
    ]
  }),

  takeEvery: ({ actions, workers }) => ({
    [actions.changeQuantity]: workers.changeQuantity,
    [actions.removeItem]: workers.removeItem,
  }),

  workers: {
    * changeQuantity(action) {
      const {item, quantity} = action.payload || {};

      if(item && item.id) {
        if(quantity > 0) {
          yield put(CartItems.actions.update.request(item.id, {
            quantity
          }))
        } else {
          yield put(CartItems.actions.del.request(item.id, item))
        }
      }
    },
    * removeItem(action) {
      const {item} = action.payload || {};

      if(item && item.id) {
        yield put(CartItems.actions.del.request(item.id, item))
      }
    },
  }
})
